module.exports = __webpack_public_path__ + "static/media/mug-tea.390bd82e.svg";